import React from "react";

export const ScrollToElement = (ref: React.RefObject<HTMLDivElement | null>, id: string, time = 3000) => {
  setTimeout(() => {
    const container = ref.current;
    if (!container || !id) {
      return;
    }

    const element: HTMLElement | null = container.querySelector(`[data-object-id="${id}"]`);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, time);
};

/** Класс временной подсветки элемента, открытого по ссылке (см. Spendings.module.scss) */
export const LINKED_FLASH = "linked-flash";

/**
 * Прокрутить к элементу `[data-object-id]` и ненадолго подсветить его рамкой. Элемент может
 * появиться не сразу — внутри раскрываемых групп, которые монтируются при раскрытии, — поэтому
 * ищем его несколько раз
 */
export const RevealElement = (
  ref: React.RefObject<HTMLDivElement | null>,
  id: string,
  { flash = true, attempts = 20, interval = 150 } = {}
) => {
  let left = attempts;

  const tryReveal = () => {
    let element: HTMLElement | null = ref.current?.querySelector(`[data-object-id="${id}"]`) ?? null;

    // якорь без своей коробки (display: contents) — показываем его содержимое
    if (element && element.getClientRects().length === 0) {
      element = element.firstElementChild as HTMLElement | null;
    }

    if (!element) {
      if (--left > 0) {
        setTimeout(tryReveal, interval);
      }
      return;
    }

    // отметка оплаты внутри карточки планового платежа — подсвечиваем всю карточку, узкая строка
    // «Оплачено» заметна хуже. Якоря секций (section-…) карточками не считаем
    const card = element.parentElement?.closest<HTMLElement>("[data-object-id]:not([data-object-id^='section-'])");
    if (card) {
      element = card;
    }

    element.scrollIntoView({ behavior: "smooth", block: "center" });

    if (flash) {
      // перезапуск анимации, если элемент уже подсвечивали
      element.classList.remove(LINKED_FLASH);
      void element.offsetWidth;
      element.classList.add(LINKED_FLASH);
      element.addEventListener("animationend", () => element.classList.remove(LINKED_FLASH), { once: true });
    }
  };

  // ждём, пока раскроются секция и группа
  setTimeout(tryReveal, interval * 2);
};
